import classNames from 'classnames'
import { BreakoutButton } from 'components/design-system/BreakoutButton'
import type { ButtonProps } from 'components/design-system/BreakoutButton'

interface BreakoutTabButtonProps extends Omit<ButtonProps, 'size'> {
  isSelected: boolean
  size?: 'medium' | 'small'
}

export const BreakoutTabButton = ({
  isSelected,
  className,
  size = 'medium',
  ...props
}: BreakoutTabButtonProps) => (
  <BreakoutButton
    {...props}
    role="tab"
    aria-selected={isSelected}
    ripple={false}
    className={classNames(
      'rounded-t-lg! rounded-b-none!',
      'focus-ring-inside',
      size === 'medium' && 'px-4!',
      isSelected && 'border-b-2 border-b-fixed-accent-color text-on-surface!',
      !isSelected && 'text-on-surface-var!',
      size === 'small' &&
        isSelected &&
        'text-label-medium! font-medium! [text-shadow:0_0_0.5px_currentColor]',
      size === 'small' && !isSelected && 'text-body-medium!',
      size === 'medium' &&
        isSelected &&
        'text-label-large! font-medium! [text-shadow:0_0_0.5px_currentColor]',
      size === 'medium' && !isSelected && 'text-body-large!',
      className
    )}
    kind={props.kind ?? 'tertiary'}
    size={size}
  />
)
